import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import { Clickable } from 'phoenix-components';

import { closeIcon } from 'components/utils/icon';

import styles from './ImageAlert.module.css';

function ImageAlert({ onClose, image }) {
  return (
    <Dialog
      PaperProps={{
        classes: {
          root: styles.paper,
        }
      }}
      open={true}>
      <div className={styles.container} style={{ backgroundImage: `url(${image})` }}>
        <Clickable className={styles.closeImage} onClick={onClose}>{closeIcon()}</Clickable>
      </div>
    </Dialog>
  );

}

ImageAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
};

export default ImageAlert;
